import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-alert__icon"
}
const _hoisted_2 = { class: "app-alert__content" }

import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppAlert',
  props: {
  type: {
    type: String as PropType<'error'>,
  },
  circular: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String as PropType<'sm' | 'lg'>,
    default: 'lg',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'app-alert',
      `app-alert--${__props.type}`,
      __props.circular ? `app-alert--circular` : ''
    ])
  }, [
    (_ctx.$slots.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "icon")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})